import { render, staticRenderFns } from "./ForumBlogSettingsAdmin.vue?vue&type=template&id=2ff6e785"
import script from "./ForumBlogSettingsAdmin.vue?vue&type=script&lang=js"
export * from "./ForumBlogSettingsAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports